'use client';

import classes from './page-tabs.module.scss'; // Import the CSS module
import Link from '@next-app/components/elements/Link/Link';
import getUniqueKey from '@next-app/utils/get-unique-key';
interface Tab {
  searchPageUrl: string; // URL to navigate to when clicked
  tabNameFormat: string; // Name/label of the tab
  totalNumRecs: number;
  active: string; // Indicates if the tab is active
}

interface TabComponentProps {
  tabs: Tab[];
}

const PageTabs = ({ tabs }: TabComponentProps) => {
  return (
    <ul className={`d-flex ${classes['tabContainer']}`}>
      {tabs.map((tab, index) => {
        const isActive = tab.active === 'true';
        const haveRecords = tab.totalNumRecs > 0;
        return (
          <li
            key={getUniqueKey(index, 'PageTabs')}
            className={`light ${classes['tabItem']} ${
              isActive ? `bold ${classes['active']}` : ''
            }`}
          >
            <Link
              aria-current={isActive ? 'page' : undefined}
              href={haveRecords ? tab.searchPageUrl : undefined}
            >
              {tab.tabNameFormat}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default PageTabs;
